/* Canvas, length, poster, mini loop and chapters for the Needs your attention film.
   Kept free of the film's code so the registry (in the main bundle) can size
   the player before the film itself loads. The beats live here too, so the
   chapters and the film's timeline share one set of numbers. */
export const FPS = 60
export const WIDTH = 1200
export const HEIGHT = 740

/** The film's beats in 60 fps frames: the landing's queue-feature timeline,
    with a longer call beat for the recording and a closing beat. */
export const BEATS = {
  home: 0,
  handoff: 180,
  /** Caption 1 hands over to caption 2 once the list has settled. */
  captionSwap: 208,
  zoom: 330,
  call: 390,
  request: 660,
  promise: 885,
  escalation: 1065,
  question: 1260,
  answer: 1308,
  answerComplete: 1374,
  send: 1410,
  learned: 1458,
  /** The camera pulls back out for the closing caption. */
  release: 1530,
  /** The answered item leaves the list… */
  done: 1596,
  /** …and the next one opens. */
  next: 1606,
  /** Exactly 0:30. */
  end: 1800,
} as const

export const DURATION = BEATS.end
/** Zoomed in on the call, the recording ready to play: its own disc shows
    Play, like the card's play disc drawn over the poster. */
export const POSTER = 420
/** The peek tab's loop: from the list and the handoff pane, through the call
    and the answer, to the next item open; the compact film fades back to the
    loop's first picture over its last frames. */
export const MINI = { from: BEATS.handoff + 24, to: BEATS.next + 120 }
export const CHAPTERS = [
  { label: 'The list', from: BEATS.home },
  { label: 'What happened', from: BEATS.zoom },
  { label: 'Your answer', from: BEATS.question - 24 },
]
